import { render } from "./Mo_claimlist_row.vue?vue&type=template&id=587062a8&scoped=true&ts=true"
import script from "./Mo_claimlist_row.vue?vue&type=script&lang=ts"
export * from "./Mo_claimlist_row.vue?vue&type=script&lang=ts"

import "./Mo_claimlist_row.vue?vue&type=style&index=0&id=587062a8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587062a8"]])

export default __exports__